export function popupLink() {
    $(window).on("load", function () {
        const mainWrap = $("body");
        const videoPopup = $('#popup-video');

        function closePopup() {
            videoPopup.find('.video-content').html('');
            $(".popup").removeClass("open");
            mainWrap.removeClass("popup-open");
        }

        $(document).on("click", ".popup-link", function (event) {
            event.preventDefault();

            let $this = $(this);
            let $target = $this.attr("href");

            if ($this.hasClass('play-video')) {
                let video;
                const downloadableSrc = $this.data("src");
                const href = $this.data("href");

                $target = '#popup-video';

                if (href !== '#') {
                    const embedSrc = !href.includes('wistia') ? href + '?enablejsapi=1&autoplay=0' : href + '?autoPlay=true';
                    video = `<iframe class="${href.includes('wistia') ? 'has-wistia' : ''}" src="${embedSrc}" frameborder="0" allow="autoplay" allowfullscreen playsinline></iframe>`

                }
                if (downloadableSrc) {
                    video = '<video controls playsinline src="' + downloadableSrc + '"></video>'

                }

                videoPopup.find('.video-content').append(video);


                const videoIframe = videoPopup.find('iframe:not(.has-wistia)');
                const videoHTML = videoPopup.find('video');

                setTimeout(() => {
                    if (videoIframe.length) {
                    videoIframe[0].contentWindow.postMessage('{"event":"command", "method":"play", "func":"' + 'playVideo' + '","args":""}', '*');
                }
                if (videoHTML.length) {
                    videoHTML[0].play();
                }
            }, 1700);


            }

            $($target).addClass("open").fadeIn(300);
            mainWrap.addClass("popup-open");
            if ($(".jcf-scrollable").length && $("body").hasClass("no-touch")) {
                jcf.replaceAll();
            }

        }).on("click", ".popup-close", function () {
            closePopup.call(this);
        });


        $(".popups").on("click", function (event) {
            if (!$(event.target).closest(".popup-holder").length) {
                closePopup.call(this);
            }
        });
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popupLink.js